const productDetail = document.querySelector('.product-detail');

if (productDetail) {
  const intensityLevelElem = document.querySelector('.intensity-level');
  const intensityLevelPaths = document.querySelectorAll('.intensity-level__group-path');
  const intensityLevel = parseInt(intensityLevelElem.getAttribute('data-intensity'), 10);
  const intensityCounter = intensityLevelElem.querySelector('.intensity-level__count-inner');

  const triggerElem = windowWidth() < breakpointMd ? '.product-detail__indicators' : '.product-detail';

  // Animate intensity level
  if (!isNaN(intensityLevel) && intensityLevel > 0) {
    const pathsArray = Array.from(intensityLevelPaths).reverse();
    gsap.set(pathsArray, { fill: '#cca75b', opacity: 0 });

    const intensityTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: triggerElem,
        start: 'top 70%',
        end: 'bottom 70%',
        // markers: true,
      },
    });

    intensityTimeline.to(
      { count: 0 },
      {
        count: intensityLevel,
        duration: 0.8,
        ease: 'linear',
        onUpdate() {
          const currentCount = Math.floor(this.targets()[0].count);
          intensityCounter.textContent = currentCount;

          pathsArray.forEach((path, index) => {
            if (index < currentCount) {
              gsap.to(path, { fill: '#000', opacity: 0.6, duration: 0.3 });
            }
          });
        },
      },
    );
  }

  // Animate roasting level
  const roastingElem = document.querySelector('[data-roasting]');
  const roastingLevel = roastingElem?.dataset.roasting;

  const roastingConfig = {
    dark: [
      ['.roasting-level__group--4 .roasting-level__group-path', '#cca75b'],
      ['.roasting-level__group--3 .roasting-level__group-path', '#9b7f45'],
      ['.roasting-level__group--2 .roasting-level__group-path', '#cca75b'],
      ['.roasting-level__group--2 .roasting-level__group-background', '#000000', 0.56, '<'],
      ['.roasting-level__group--1 .roasting-level__group-background', '#cca75b'],
      ['.roasting-level__group--1 .roasting-level__group-background', '#000000', 0.8, '<'],
    ],
    'medium-dark': [
      ['.roasting-level__group--4 .roasting-level__group-path', '#cca75b'],
      ['.roasting-level__group--3 .roasting-level__group-path', '#9b7f45'],
      ['.roasting-level__group--2 .roasting-level__group-path', '#cca75b'],
      ['.roasting-level__group--2 .roasting-level__group-background', '#000000', 0.56, '<'],
    ],
    medium: [
      ['.roasting-level__group--4 .roasting-level__group-path', '#cca75b'],
      ['.roasting-level__group--3 .roasting-level__group-path', '#9b7f45'],
    ],
    light: [['.roasting-level__group--4 .roasting-level__group-path', '#cca75b']],
  };

  if (roastingLevel && roastingConfig[roastingLevel]) {
    const roastingTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: triggerElem,
        start: 'top 70%',
        end: 'bottom 70%',
      },
    });

    roastingConfig[roastingLevel].forEach(([selector, fill, opacity = 1, timing]) => {
      roastingTimeline.to(selector, { fill, opacity, duration: 0.12 }, timing);
    });

    roastingTimeline.to('.roasting-level__count', { opacity: 1 });
  }
}
